import * as React from "react"
import Button from "@mui/material/Button"
import Dialog from "@mui/material/Dialog"
import DialogActions from "@mui/material/DialogActions"
import DialogContent from "@mui/material/DialogContent"
import { ListGroup } from "react-bootstrap"
import { Link } from "react-router-dom"
import { Lock } from "react-feather"
import AllTextState from "../../../../assets/shared/state/AllTextState"
import SwitchTenantModal from "../../../../assets/js/pages/tenant/SwitchTenantModal"
import { getData } from "../../../../assets/shared/api/ApiCalls"

const SwitchTenant = (): JSX.Element => {
  const [open, setOpen] = React.useState(false)
  const [tenants, setTenants] = React.useState<any>()

  const handleClickOpen = () => {
    setOpen(true)
  }

  const handleClose = () => {
    setOpen(false)
  }

  React.useEffect(() => {
    getData("rest/get_tenants_by_user", setTenants)
  }, [])

  if(!tenants) return <></>
  if(tenants && tenants?.length < 2) return <></>
  return (
    <div>
      <ListGroup.Item as="li" bsPrefix=" ">
        <Link to="#" className="dropdown-item" onClick={handleClickOpen}>
          <Lock size={16} className="m-r-10" />
          {AllTextState.switchTenant}
        </Link>
      </ListGroup.Item>

      <Dialog
        open={open}
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogContent>
          <SwitchTenantModal closeFunc={handleClose} tenants={tenants}/>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose}>Close</Button>
        </DialogActions>
      </Dialog>
    </div>
  )
}

export default SwitchTenant
